import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import Lightbox from 'bs5-lightbox';

export default class extends Controller {

  static values = { gallery: String }

  connect() {
    Loggable(this, { debug: false })

    this.lightbox = new Lightbox(this.element, {
      keyboard: true,
      size: "fullscreen",
      gallery: this.galleryValue,
      constrain: true
    })

    this.lightbox.modalElement.classList.add("media-gallery-lightbox")

    this.lightbox.modalElement.querySelectorAll(".ratio-16x9").forEach((stage) => {
      stage.classList.add("media-gallery-lightbox__stage")
    })

    this.lightbox.modalElement.addEventListener("hidden.bs.modal", () => {
      this.modalOpen = false
      if (this.trigger?.isConnected) this.trigger.focus()
    })
    this.lightbox.modalElement.addEventListener("show.bs.modal", () => { this.modalOpen = true })
    this.beforeCache = () => this.cleanup()
    document.addEventListener("turbo:before-cache", this.beforeCache)
  }

  cleanup() {
    if (!this.lightbox) return
    const { modal, modalElement, carousel } = this.lightbox
    // Finish Bootstrap's transitions before Turbo snapshots the body scroll state.
    const backdrop = this.modalOpen ? Array.from(document.querySelectorAll(".modal-backdrop")).pop() : null
    backdrop?.dispatchEvent(new Event("transitionend"))
    modalElement.querySelector(".modal-dialog").dispatchEvent(new Event("transitionend"))
    modal.hide()
    modalElement.dispatchEvent(new Event("transitionend"))
    backdrop?.dispatchEvent(new Event("transitionend"))
    modal.dispose()
    modalElement.querySelector(".carousel-item.active")?.dispatchEvent(new Event("transitionend"))
    carousel.dispose()
    modalElement.remove()
    this.lightbox = null
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.cleanup()
  }

  show(e){
    e.preventDefault()
    this.trigger = e.currentTarget
    const sources = [...new Set(Array.from(this.element.querySelectorAll("a[data-gallery]"), (link) => link.href))]
    const index = sources.indexOf(this.trigger.href)
    if (index >= 0) this.lightbox.carousel.to(index)
    this.lightbox.show();
  }

}
